import { render, staticRenderFns } from "./PriceGroupsForm.template.vue?vue&type=template&id=4e640384&scoped=true&"
var script = {}
import style0 from "./PriceGroupsForm.template.vue?vue&type=style&index=0&id=4e640384&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e640384",
  null
  
)

export default component.exports